/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-score';
const componentName = 'avi-health-score-bars';
const prefix = `${moduleName}.${componentName}`;

export const performanceLabel = `${prefix}.performanceLabel`;
export const resourceLabel = `${prefix}.resourceLabel`;
export const anomalyLabel = `${prefix}.anomalyLabel`;
export const penaltiesLabel = `${prefix}.penaltiesLabel`;

export const ENGLISH = {
    [performanceLabel]: 'Performance',
    [resourceLabel]: 'Resource',
    [anomalyLabel]: 'Anomaly',
    [penaltiesLabel]: 'Penalties',
};
